import FileDownloadIcon from '@mui/icons-material/GetApp';
import LoadingButton from '@mui/lab/LoadingButton';
import React, { useContext, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import {
  Box, Link, Skeleton, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography,
} from '@mui/material';
import {
  QuestionViewModalContext,
} from 'components/Question/QuestionDetails/QuestionViewModal/QuestionViewModalProvider';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch } from 'react-redux';


export const DownloadArtifactFile = () => {
  const dispatch = useDispatch();
  const {
    artifactFileDetails,
    refetchDownloadArtifactFile,
  } = useContext(QuestionViewModalContext);
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    setIsLoading(true);
    let url;
    try {
      const response = await refetchDownloadArtifactFile();
      const file = response?.data?.data;
      const headers = response?.data?.headers;
      if (!file || !headers) {
        throw new Error('Invalid response from server');
      }
      const disposition = headers.get('Content-Disposition');
      const match = disposition?.match(/filename="?([^"]+)"?/);
      const filename = match?.[1] || artifactFileDetails?.fileName || 'download.whl';
      const blob = new Blob([file], { type: 'application/octet-stream' });
      url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
    }
    catch (error) {
      dispatch(showAlert({ message: `Error downloading file: ${error}`, type: 'error' }));
    }
    finally {
      if (url) URL.revokeObjectURL(url);
      setIsLoading(false);
    }
  };

  if (isEmpty(artifactFileDetails)) {
    return <Skeleton height={200} />;
  }

  return (
    <Stack gap={2}>
      <Box display='flex' justifyContent='space-between'>
        <Typography variant='subtitle1'>
          {artifactFileDetails?.fileName}
        </Typography>
        <LoadingButton
          loading={isLoading}
          disabled={isLoading}
          variant='contained'
          color='primary'
          onClick={handleDownload}
        >
          <FileDownloadIcon fontSize='small' />
          Download
        </LoadingButton>
      </Box>
      <Typography variant='linkText'>
        Learn more about
        {' '}
        <Link
          href='https://docs.liveramp.com/clean-room/en/clean-compute-on-apache-spark.html#clean-compute-on-apache-spark'
          target='_blank'
          rel='noreferrer'
        >
          installing packages
        </Link>
      </Typography>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell sx={{ borderBottom: '2px solid #707070' }}>File Name</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {artifactFileDetails?.packageFiles?.map((pf) => (
            <TableRow key={pf}>
              <TableCell>{pf}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Stack>
  );
};
